import { useTranslator } from "@eo-locale/react";

import { useState } from "react";

import { Alert, Text, Button, CloseButton } from "@/storybook-components";
import { resendUserActivationEmail } from "@/models";
import { useAppSelector } from "@/redux/store/hooks";
import { fetchAuthToken } from "@/helpers/fetch-auth-token";

const ResendVerificationCode = (): JSX.Element => {
  const { translate } = useTranslator();
  const [isCodeSent, setIsCodeSent] = useState(false);
  const user = useAppSelector((state) => state.user);
  const anonymousUser = useAppSelector((state) => state.anonymousUser);
  const { token } = fetchAuthToken({ user, anonymousUser });
  const { baseUrl } = useAppSelector((state) => state.adapter.adapter);
  const { registrations } = useAppSelector((state) => state.registrations);

  const handleClick = () => {
    resendUserActivationEmail(token, baseUrl, registrations.id);
    setIsCodeSent(true);
  };

  if (isCodeSent)
    return (
      <Alert.Root status="success" borderRadius="md" my={5}>
        <Alert.Indicator />
        {translate("register.requestNewCodeInfo")}
        <CloseButton
          color="white"
          _hover={{ bg: "whiteAlpha.300" }}
          _active={{ bg: "whiteAlpha.400" }}
          onClick={() => setIsCodeSent(false)}
          data-testid="accountVerification-codeSentAlertClose"
        />
      </Alert.Root>
    );

  return (
    <Text my="2">
      {translate("register.didnotReceiveCode")} &nbsp;
      <Button
        variant="link"
        onClick={handleClick}
        data-testid="accountVerification-requestNewCodeButton"
      >
        {translate("register.requestNewCode")}
      </Button>
    </Text>
  );
};

export default ResendVerificationCode;
